import { createConfigParametersRepository } from '../../configParametersRepository';
import { PAGE_RENDER_ID } from '../pageRenderID';

export const getPageRenderId = () => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const pageRenderId = storageClient?.getFromStorage(
    'sessionStorage',
    PAGE_RENDER_ID,
    null
  );
  return pageRenderId || window?.__htmlEvents__?.pageRenderId;
};
